<template>
    <a
        :class="'associated-documents-item select-item'"
        @click="selectModal()"
    >

        <template >
            <div class="top-part" >
                <span class="icon-file-pdf" :class="brandColor"></span>


            </div>
            <div class="bottom-part">
                <div class="details">
                    <h4 class="document-title" >{{$t(document.type)}}</h4>
                    <div class="download-button">
                      <span class="icon-download" :class="brandColor"></span>
                    </div>
                </div>
            </div>
        </template>
    </a>
</template>

<script>
    import axios from 'axios'
    import { saveAs } from 'file-saver';
    import {downloadBlobFilename} from "@/common/helpers"
    import assetService from "@/services/akeneo/asset";
    import serliAssetService from "@/services/serli/asset";
    import SheetBlockAssociatedBrochuresSelect from "@/components/SheetBlock/SheetBlockAssociatedBrochuresSelect";


    export default {
        name: 'AssociatedDocumentsItem',
        props: {
            document: {
                type: Object,
                default: null
            },
            isBtn: {
                type: Boolean,
                default: false
            },
        },
      components: {
        SheetBlockAssociatedBrochuresSelect,
      },
        methods: {

      selectModal(){
        this.$buefy.modal.open({
          parent: this,
          component: SheetBlockAssociatedBrochuresSelect,
          hasModalCard: true,
          customClass: 'custom-class custom-class-2',
          trapFocus: true,
          props : {'document':this.document}
        })
      },
            documentLink(document){
                if(document.link && !document.forceLinkDownload)
                    return document.link
                else
                    return 'javascript:;'
            },
            async downloadDocument(document){
                const userAgent = window.navigator.userAgent.toLowerCase();
                const isIos = (!!userAgent.match(/iphone/i) || !!userAgent.match(/ipad/i));
                if(document.link){
                    if(document.forceLinkDownload){
                        if(isIos){
                            window.open(document.link)
                        }
                        else {
                            this.startLoading(this.$t('download_in_progress_please_wait'));
                            axios({
                                url: document.link,
                                method: 'GET',
                                responseType: 'blob',
                            })
                            .then((response) => {
                                const blob = new Blob([response.data]);
                                saveAs(blob, document.filename)
                            })
                            .finally(() => this.stopLoading());
                        }
                    }
                } else {
                    this.startLoading(this.$t('download_in_progress_please_wait'));
                    if(document.isSerli){
                        const assetDatas = await serliAssetService.download(document.code, {
                            locale: this.$store.state.settings.locale
                        })
                        .then((response) => {
                            if(response.data.code === 200)
                                return response.data.data;
                            else if(response.data.code === 500){
                                console.error(response.data.message)
                                return null
                            }
                        })

                        if(assetDatas){
                            if(isIos){
                                window.open(assetDatas.url, '_self')
                            }
                            else {
                                const assetBlob = await axios({
                                    url: assetDatas.url,
                                    method: 'GET',
                                    responseType: 'blob',
                                })
                                .then((response) => response.data)
                                saveAs(new Blob([assetBlob]), document.filename)
                            }
                        }
                        else {
                            this.$buefy.dialog.alert({
                                title: 'Error',
                                message: this.$t('this_file_is_not_available_for_download'),
                                type: 'is-danger'
                            })
                        }
                    }
                    else {
                        let assetDatas = await assetService.download(document.code, {
                            type: 'document',
                            locale: this.$store.state.settings.locale
                        }).then((response) => response.data)

                        if(assetDatas.size > 0) {
                            downloadBlobFilename(document.filename, new Blob([assetDatas]))
                        }
                        else if (this.$store.state.settings.locale !== 'en_US') {
                            assetDatas = await assetService.download(document.code, {
                                type: 'document',
                                locale: 'en_US'
                            }).then((response) => response.data);

                            if(assetDatas.size > 0) {
                                downloadBlobFilename(document.filename, new Blob([assetDatas]))
                            }
                        }
                    }

                    this.stopLoading();
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.associated-documents-item {
    position: relative;
    flex: 0 0 calc((100%/6) - 20px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 10px;
    height: 230px;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 20px 20px 74px 0 rgba(0, 0, 0, 0.15);
    background-color: $white;
    border: solid 2px $white;
    transition: border-color 0.3s ease;

    @media #{$mq_large_desktop} {
        flex: 0 0 calc((100%/5) - 20px);
    }

    @media #{$mq_small_desktop} {
        flex: 0 0 calc((100%/4) - 20px);
    }

    @media #{$mq_tablet} {
        flex: 0 0 calc((100%/3) - 20px);
    }

    @media #{$mq_phone} {
        flex: 0 0 100%;
        margin: 0 0 20px 0;
    }

    @each $brand in $brands {
        .brand-#{$brand} & {
            &:hover {
                border: solid 2px brand-color($brand);
            }
        }
    }

    .top-part {
        flex: 1 1 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40%;
        width: 100%;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;

        [class^="icon-"], [class*=" icon-"] {
            display: block;
            font-size: 60px;
        }
    }

    .bottom-part {
        position: relative;
        flex: 1 1 auto;
        height: 60%;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        width: 100%;
      padding-bottom:30px;


        .details {

            .document-title {
                font-size: 18px;
                font-weight: 900;
                line-height: 1;
                margin-bottom: 10px;
                padding: 0 20px;
               // height: 40px;
              text-align: center;

                @media #{$mq_small_desktop} {
                    //height: 50px;
                }
            }

          .download-button {
            position: absolute;
            bottom: 15px;
            text-align: center;
            width: 100%;
            left: 0;
          }
            [class^="icon-"], [class*=" icon-"] {
                display: block;
                font-size: 30px;
            }
        }
    }
}
.modal .animation-content {
  z-index:1;
}

</style>
